// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tools-popover .g-popover{margin-right:-36px;margin-top:15px!important;box-shadow:0 10px 32px rgba(0,0,0,.1)!important;border-radius:4px!important}", ""]);
// Exports
module.exports = exports;
